import Footer from "../components/Footer";
import Header from "../components/Header";

const Privacy = () => {
  return (
    <>
      <Header />
      <main className="py-12 bg-white flex justify-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <h1 className="text-3xl leading-9 font-extrabold text-gray-900">
            Privacy Policy
          </h1>
          <div className="mt-6 text-gray-600 text-lg leading-7">
            <p>
              At PottersTouch LLC, we respect your privacy and are committed to
              protecting it. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you visit our
              website.
            </p>
            <p>
              We reserve the right to make changes to this Privacy Policy at any
              time and for any reason. Any changes or modifications will be
              effective immediately upon posting the updated Privacy Policy on
              the website.
            </p>
            <p>
              The website uses cookies to enhance your user experience. You can
              turn off the use of cookies at any time by changing your specific
              browser settings. Our website may contain links to other websites
              of interest. However, once you have used these links to leave our
              site, you should note that we do not have any control over that
              other website. Therefore, we cannot be responsible for the
              protection and privacy of any information which you provide whilst
              visiting such sites.
            </p>
            <p>
              If you have any questions or comments about this Privacy Policy,
              please contact us at: potterstouchagency@gmail.com
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Privacy;
